import React from 'react';
import { WebsiteDesignProps } from './types';
import { Glasses, Drama, Sparkles } from 'lucide-react';
import { Button } from "@/components/ui/button";

const TheatreArts: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Academy of Dramatic Arts";

    return (
        <div className="bg-[#1a0a0a] min-h-screen font-serif text-[#f5f0e8]">
            {/* Curtain-like decoration */}
            <div className="absolute top-0 left-0 right-0 h-4 bg-gradient-to-b from-[#8b0000] to-transparent"></div>

            <nav className="px-12 py-8 flex justify-between items-center relative z-10">
                <div className="text-2xl font-light italic tracking-wide">
                    {schoolName}
                </div>
                <div className="hidden md:flex gap-8 text-sm font-sans uppercase tracking-widest text-[#f5f0e8]/60">
                    <a href="#" className="hover:text-[#8b0000] transition-colors">Productions</a>
                    <a href="#" className="hover:text-[#8b0000] transition-colors">Training</a>
                    <a href="#" className="hover:text-[#8b0000] transition-colors">Alumni</a>
                </div>
            </nav>

            <header className="relative py-32 px-12 text-center">
                <div className="absolute inset-0 flex justify-center items-center opacity-5">
                    <Drama size={400} strokeWidth={0.5} />
                </div>
                
                <div className="relative z-10 max-w-4xl mx-auto">
                    <Sparkles className="mx-auto text-[#8b0000] mb-8" size={32} />
                    <h1 className="text-6xl md:text-8xl font-light mb-8 leading-none italic">
                        All the World's <br/> a Stage.
                    </h1>
                    <p className="text-xl text-[#f5f0e8]/70 max-w-lg mx-auto mb-12 font-sans font-light leading-relaxed">
                        Transform passion into performance. Train with masters of the craft in our legendary studios.
                    </p>
                    <div className="flex justify-center gap-6">
                        <Button className="bg-[#8b0000] text-white hover:bg-[#6b0000] font-sans uppercase tracking-widest text-xs px-10 py-6 rounded-none">
                            Apply Now
                        </Button>
                        <Button variant="outline" className="border-[#f5f0e8]/30 text-[#f5f0e8] hover:bg-[#f5f0e8]/10 font-sans uppercase tracking-widest text-xs px-10 py-6 rounded-none">
                            View Season
                        </Button>
                    </div>
                </div>
            </header>

            <section className="bg-[#8b0000] py-16">
                <div className="max-w-6xl mx-auto px-12 flex flex-wrap justify-center gap-12 text-center text-white">
                    <div>
                        <div className="text-5xl font-light mb-2">1923</div>
                        <div className="text-xs font-sans uppercase tracking-widest opacity-70">Est.</div>
                    </div>
                    <div className="w-px bg-white/20"></div>
                    <div>
                        <div className="text-5xl font-light mb-2">450+</div>
                        <div className="text-xs font-sans uppercase tracking-widest opacity-70">Alumni on Broadway</div>
                    </div>
                    <div className="w-px bg-white/20"></div>
                    <div>
                        <div className="text-5xl font-light mb-2">12</div>
                        <div className="text-xs font-sans uppercase tracking-widest opacity-70">Tony Awards</div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default TheatreArts;
